import AgencyGroupList from '@/components/AgencyGroup/AgencyGroupList'
import AgencyGroupForm from '@/components/AgencyGroup/AgencyGroupForm'

let AgencyGroupRouter = [{
  path: '/agencygroup',
  name: 'AgencyGroupList',
  component: AgencyGroupList,
  meta: {
    title: "Groupes d'agences",
    requiresAuth: true,
    authorizations: ['agency_index', 'desktop_access']
  }
}, {
  path: '/agencygroup/new',
  name: 'AgencyGroupNew',
  component: AgencyGroupForm,
  meta: {
    title: "Nouveau groupe d'agences",
    requiresAuth: true,
    authorizations: ['agencygroup_new', 'desktop_access']
  }
}, {
  path: '/agencygroup/:id/edit',
  name: 'AgencyGroupEdit',
  component: AgencyGroupForm,
  meta: {
    title: "Modifier un groupe d'agences",
    requiresAuth: true,
    authorizations: ['agencygroup_edit', 'desktop_access']
  }
}]

export default AgencyGroupRouter



// WEBPACK FOOTER //
// ./src/components/AgencyGroup/router.js